import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  step: 1,
  answers: null,
  careers: [],
  selectedCareers: [],
};

const riasecSlice = createSlice({
  name: 'riasec',
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setCareers: (state, action) => {
      state.careers = action.payload;
    },
    setSelectedCareers: (state, action) => {
      state.selectedCareers = action.payload;
    },
    resetRiasec: () => {
      return initialState;
    },
  },
});

// Export actions
export const {
  setStep,
  setAnswers,
  setCareers,
  setSelectedCareers,
  resetRiasec,
} = riasecSlice.actions;

// Export selectors
export const selectRiasecStep = (state) => state.riasec.step;
export const selectRiasecAnswers = (state) => state.riasec.answers;
export const selectCareers = (state) => state.riasec.careers;
export const selectSelectedCareers = (state) => state.riasec.selectedCareers;

export default riasecSlice.reducer;
